// extracted by mini-css-extract-plugin
module.exports = {"ErrorLabel":"ErrorLabel_ErrorLabel__1EBdh"};